// /src/store/reducers/index.js

import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authReducer";
import billingReducer from "./billingReducer";
import settingsReducer from "./settingsReducer";
import loaderReducer from "./loaderReducer";

// ... other reducers
const rootReducer = combineReducers({
  auth: authReducer,
  billing: billingReducer,
  settings: settingsReducer,
  loader: loaderReducer,
  // ... other reducers
});

export default rootReducer;
